
import { ProThemeBodyFont, proThemeBodyFontOptions, ProThemeMotif, proThemeMotifOptions, ProThemeTitleFont, proThemeTitleFontOptions, ProThemeCornerStyle, proThemeCornerStyleOptions, ProThemeShadowStyle, proThemeShadowStyleOptions } from './proThemeOptions'

export type TypedProThemeSettings = {
  colorPrimary: string
  colorSecondary: string
  colorNeutralLight: string
  colorNeutralDark: string
  titlesFont: ProThemeTitleFont
  titlesMotif: ProThemeMotif
  bodyFont: ProThemeBodyFont
  cornerStyle: ProThemeCornerStyle
  shadowStyle: ProThemeShadowStyle
}

function typedThemeOption<T extends readonly string[]>(
  motif: string,
  validMotifs: T,
): T[number] | 'unknown' {
  if (!validMotifs.includes(motif as T[number])) {
    return 'unknown'
  }
  return motif as T[number]
}

export function createTypedProThemeSettings(settings: ProThemeSettings): TypedProThemeSettings {
  return {
    ...settings,
    titlesFont: typedThemeOption(settings.titlesFont, proThemeTitleFontOptions),
    titlesMotif: typedThemeOption(settings.titlesMotif, proThemeMotifOptions),
    bodyFont: typedThemeOption(settings.bodyFont, proThemeBodyFontOptions),
    cornerStyle: typedThemeOption(settings.cornerStyle, proThemeCornerStyleOptions),
    shadowStyle: typedThemeOption(settings.shadowStyle, proThemeShadowStyleOptions),
  }
}

export const defaultProThemeSettings: TypedProThemeSettings = {
  colorPrimary: '#d86ece',
  colorNeutralLight: '#fdf9f7',
  colorSecondary: '#f6edea',
  colorNeutralDark: '#000000',
  titlesFont: 'croissantOne',
  titlesMotif: 'box',
  bodyFont: 'archivo',
  cornerStyle: 'square',
  shadowStyle: 'none',
}

export const migrateProThemeSettings = (saasSettings: SaasSettings) => {
  if (!saasSettings?.themeSettings?.createdAt) {
    if (!saasSettings.themeSettings) {
      saasSettings.themeSettings = { ...defaultProThemeSettings }
    }
    saasSettings.themeSettings.colorPrimary = saasSettings.themePrimary || defaultProThemeSettings.colorPrimary
    saasSettings.themeSettings.colorSecondary = saasSettings.themeBackground || defaultProThemeSettings.colorSecondary
    saasSettings.themeSettings.colorNeutralLight = '#ffffff'
    saasSettings.themeSettings.colorNeutralDark = '#000000'
  }

  return saasSettings
}
